'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FullScreenOverlay = require('./components/FullScreenOverlay.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FullScreenOverlay).default;
  }
});
Object.defineProperty(exports, 'FullScreenOverlay', {
  enumerable: true,
  get: function get() {
    return _FullScreenOverlay.FullScreenOverlay;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-full-screen-overlay/lib/index.js
// module id = 45
// module chunks = 1